import React, { useState, useRef } from "react";
import Tooltip from "./Tooltip"; 
import weekend from "../images/weekend.png"

const buttonLabels = [
  "Shockwave", "Morale", "Meteors", "Missile", "Mines", "Vengeance",
  "Freeze", "Decoy", "Buff", "Possess", "Heal", "Medusa",
  "Push", "Recover", "Necromancy", "Clone", "Black Hole", "Champion"
];
const weekendStats ={
    "normal": {
        "Attack": 1,
        "Health": 1,
        "Base Health": 1,
        "Crit %": 0
    },
    "hard": {
        "Attack": 1.5,
        "Health": 1.5,
        "Base Health": 1.5,
        "Crit %": 2
    },
    "extreme": {
        "Attack": 2.5,
        "Health": 2.5,
        "Base Health": 2.5,
        "Crit %": 5
    },
    "nightmare": {
        "Attack": 5.5,
        "Health": 5.5,
        "Base Health": 5.5,
        "Crit %": 7
    }
}

const weekendRewards ={
    "normal": {
        "Unlock Unit 2": 10,
        "Unlock Unit 3": 20,
        "Gems": 400,
    },
    "hard": {
        "Unlock Unit 2": 15,
        "Unlock Unit 3": 25,
        "Gems": 575,
    },
    "extreme": {
        "Unlock Unit 2": 15,
        "Unlock Unit 3": 30,
        "Gems": 720,
    },
    "nightmare": {
        "Unlock Unit 2": 20,
        "Unlock Unit 3": 40,
        "Gems": 900,
    }
}
export default function CustomCalculatorCard() {
  const [dropdownValue, setDropdownValue] = useState("normal");
  const [result, setResult] = useState(null);
  const [stars, setStars] = useState(Array(18).fill(0));
  const [showTooltip, setShowTooltip] = useState(false);
  const infoRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

  const handleDropdownChange = (e) => {
    setDropdownValue(e.target.value);
  };
 const handleMouseEnter = () => {
    if (infoRef.current) {
      const rect = infoRef.current.getBoundingClientRect();
      setTooltipPos({ x: rect.left + rect.width / 2, y: rect.bottom });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleCalculate = () => {
    const attackVals = stars.slice(0, 6);
    const healthVals = stars.slice(6, 12);
    const baseVals = stars.slice(12, 18);
    const totalAttack = attackVals.reduce((product, val) => product * (val/10 + 1), 1).toPrecision(3);
    const totalHealth = healthVals.reduce((product, val) => product * (val/10 + 1), 1).toPrecision(3);
    const totalBase = baseVals.reduce((product, val) => product * (val/10 + 1), 1).toPrecision(3);
    const enemyStats = weekendStats[dropdownValue];
    const enemyEntries = Object.entries(enemyStats); 
    const keyValueStrings = enemyEntries.map(([key, value]) => `${key}: ${value}`);
    const resultString = keyValueStrings.join("\n");
    const enemyRewards = weekendRewards[dropdownValue];
    const enemyEntryRewards = Object.entries(enemyRewards);
    const keyValString = enemyEntryRewards.map(([key, value]) => `${key}: ${value}`);
    const resultRewards = keyValString.join("\n");

    const enemyformatted = {
      rows: [
          { name: "Your Stats:", val: `Attack: ${totalAttack}\nHealth: ${totalHealth}\nBase: ${totalBase}` },
          { name: "Enemy Stats:", val: resultString },
          { name: "Weekend Rewards:", val: resultRewards}
      ]
};
    setResult(enemyformatted);
  };

  const handleReset = () => {
    setDropdownValue("normal");
    
    setResult(null);
    setStars(Array(18).fill(0));
  };

  const handleStarClick = (index) => {
    setStars((prev) => {
      const newStars = [...prev];
      newStars[index] = (newStars[index] + 1) % 4; // 0 → 1 → 2 → 3 → 0
      return newStars;
    });
  };

  const renderResult = (result) => {
    if (!result || !Array.isArray(result.rows) || result.rows.length === 0) return null;

    const isRowLayout = result.rows.length > 3;
    const layoutClass = isRowLayout
      ? "flex flex-col flex-wrap gap-3"
      : "flex flex-row flex-wrap gap-3";

    return (
      <div className="card bg-white shadow-md rounded-xl p-4 mt-4 max-w-xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Result</h2>
        <div className={layoutClass}>
          {result.rows.map((row, index) => (
            <div
              key={index}
              className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-2 min-w-[150px]"
            >
              <div className="text-sm text-gray-500">{row.name}</div>
              <div className="text-lg font-semibold whitespace-pre-line">{row.val}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="relative bg-white/60 card p-6 border rounded-md shadow-md backdrop-blur-sm transition">
      {/* Header */}
      <div className="flex items-center justify-center mb-4 relative">
        <h2 className="text-2xl mr-2">Weekend Event Calculator</h2>
        <div
          ref={infoRef}
          className="text-sm text-blue-500 cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            if (window.innerWidth <= 768) {
              handleMouseEnter();
              setTimeout(() => setShowTooltip(false), 3000);
            }
          }}
        >
          ℹ️
        </div>

        {showTooltip && (
          <Tooltip
            position={{
              x: tooltipPos.x,
              y: tooltipPos.y,
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave
            }}
          >
            {"Simple calculator to determine your stats and enemy stats for the weekend event. It only calculate completed skill ascensions."}
            {weekend && (
              <img
                alt={`Info for Weekend Events`}
                src={weekend}
                className="max-w-[200px] w-full rounded-lg mt-2"
              />
            )}
          </Tooltip>
        )}
      </div>

      {/* Star Button Grid */}
     <div className="flex justify-center w-full">
  <div className="inline-grid grid-cols-3 lg:grid-cols-6 gap-3 p-2 mb-6 max-w-[1200px]">
    {buttonLabels.map((label, i) => (
      <button
        key={i}
        onClick={() => handleStarClick(i)}
        className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-blue-500 text-white flex flex-col items-center justify-center hover:bg-blue-600 transition"
      >
        <span className="text-[10px] sm:text-xs font-semibold text-center leading-tight">
          {label}
        </span>
        <span className="text-yellow-300 text-xs sm:text-sm mt-1">
          {"⭐".repeat(stars[i])}
        </span>
      </button>
    ))}
  </div>
</div>

      {/* Dropdown */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1 text-gray-700">Select Enemy Mode</label>
        <select
          className="w-full border rounded-md px-3 py-2 bg-white text-gray-800"
          value={dropdownValue}
          onChange={handleDropdownChange}
        >
          <option value="normal">Normal</option>
          <option value="hard">Hard</option>
          <option value="extreme">Extreme</option>
          <option value="nightmare">Nightmare</option>
        </select>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-4 mb-6">
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
          onClick={handleCalculate}
        >
          Calculate
        </button>
        <button
          className="bg-gray-400 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-xl"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>

      {/* Results */}
      {renderResult(result)}
    </div>
  );
}
